//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from 'clipboard';

export default {
  props: ['modelProp', 'parentpage', 'wx'],
  data() {
    return {
      orderbtn: false,
      showNewOrder: false,
      orderUrl: '/order/listbrowser.html',
      test: 1,
    };
  },
  computed: {
    wx() {
      return this.$store.state.swx;
    },
  },
  watch: {
    modelProp: {
      handler(newValue, oldValue) {
        this.setWnlBtnType(newValue.newOrderBnt);
      },
      deep: true,
    },
  },
  created() {
    this.orderbtn = window.ISWNL;
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    CopyWechat() {
      var clipboard = new Clipboard('.wxCode');
      clipboard.on('success', (e) => {
        this.$Glb.PlMessage('复制成功', 800, () => {
          window.location.href = 'weixin://';
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        // 不支持复制
        this.$Glb.PlMessage('该浏览器不支持一键复制,请长按手动复制', 800);
        // 释放内存
        clipboard.destroy();
      });
    },
    toHome() {
      this.$Glb.baiduCount('首页-更多测试');
      window.location.href = window.location.href.replace(window.location.pathname.split('/')[1], this.modelProp.homelink);
      // this.$router.push({path:this.modelProp.homelink,query:this.$route.query})
      // window.location.href = `${this.modelProp.homelink}${window.location.search}`
    },
    goMyOrder() {
      if (this.orderbtn) {
        var wnlOrderPageUrl = document.getElementsByClassName('wnl_history_btn')[0].href;
        window.location = wnlOrderPageUrl;
      } else {
        window.location = this.orderUrl;
      }
    },
    setWnlBtnType(type) {
      var wnlBtn = document.getElementsByClassName('wnl_history_btn')[0];
      try {
        if (type == 0) {
          wnlBtn.style.cssText = 'display:block !important';
        }
      } catch (error) {}
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/yscy/components/MyOrderBtn.vue